import Header from "@/reusable_sections/Header";
import PageHero from "@/components/PageHero";
import ServiceIntro from "@/components/service/ServiceIntro";
import ServiceCards from "@/components/service/ServiceCards";
import PatiosQuote from "./sections/PatiosQuote";
import OtherServices from "@/components/service/OtherServices";
import CtaBand from "@/components/CtaBand";
import Footer from "@/reusable_sections/Footer";
import { Gem, Ruler, PenTool, RefreshCw, Droplets, Maximize } from "lucide-react";
const subServices = [{
  title: "Flagstone Patios",
  description: "Timeless natural stone installations that offer unique textures and unmatched durability for your outdoor living space.",
  icon: Gem,
  to: "/PatiosPage"
}, {
  title: "Porcelain Patios",
  description: "Modern, low-maintenance paving solutions that provide a sleek, contemporary finish with exceptional stain resistance.",
  icon: Ruler,
  to: "/PatiosPage"
}, {
  title: "Design Consultation",
  description: "Expert planning and tailored layout design to transform your vision into a functional and beautiful outdoor living space.",
  icon: PenTool,
  to: "/PremiumLandscapingServicesPage"
}, {
  title: "Repairs & Restoration",
  description: "Professional cleaning, repointing, and stone replacement to bring your existing patio back to its original glory.",
  icon: RefreshCw,
  to: "/RePointingServicesPage"
}, {
  title: "Drainage Solutions",
  description: "Essential water management systems designed to protect your property and ensure your patio remains puddle-free.",
  icon: Droplets,
  to: "/ServicesHubPage"
}, {
  title: "Patio Extensions",
  description: "Seamlessly expand your existing outdoor area to create more room for entertaining, dining, and relaxation.",
  icon: Maximize,
  to: "/PatiosPage"
}];
export default function PatiosPage() {
  return <div className="min-h-screen bg-background text-foreground flex flex-col">
      <Header />

      <PageHero breadcrumbLabel="Patios" breadcrumbParent={{
      label: "Services",
      to: "/ServicesHubPage"
    }} eyebrow="OUR SERVICES" title="Patios in Southampton" intro="Transform your outdoor space with bespoke patio design, porcelain paving, and natural stone installations across Southampton, Hampshire & surrounding areas." imageSrc="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662274/img/service_patios.png" imageAlt="Porcelain and stone patio installation in Southampton by Firststop Roofing Ltd" actions={true} />

      <ServiceIntro eyebrow="EXPERT PATIO CRAFTSMANSHIP" heading="Transform Your Garden with Expert Patios in Southampton" paragraphs={["Create the perfect setting for relaxation and entertaining with bespoke patios in Southampton. As roofing and property specialists in Southampton, our team combines high-grade materials with proven groundwork expertise to enhance your outdoor living space and property value.", "From modern porcelain paving to traditional natural sandstone and flagstone, Matt and our experienced team construct every patio with deep compacted sub-bases, precision falls for effective drainage, and weed-resistant pointing to ensure lasting stability across Southampton, Hampshire & surrounding areas."]} benefits={["Premium porcelain, natural sandstone, and flagstone surfaces", "Engineered sub-base groundwork with proper gradient drainage", "Durable weather-proof jointing and long-lasting weed resistance"]} imageSrc="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1662274/img/luxury_stone_patio_landscaping.png" imageAlt="Finished natural stone patio with professional landscaping in Southampton" cta={true} />

      <ServiceCards eyebrow="WHAT WE OFFER" heading="Professional Patio Solutions in Southampton" intro="Comprehensive patio design, laying, and restoration services tailored to enhance your garden with dependable craftsmanship in Southampton, Hampshire & surrounding areas." items={subServices} columns={3} />

      <PatiosQuote />

      <OtherServices currentKey="patios" />

      <CtaBand />

      <Footer />
    </div>;
}